import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseDeRefService {
  private readonly BASEDEREF_KEY = 'basederef_token';

  getTokenFromLocal(): string | null {
    return localStorage.getItem(this.BASEDEREF_KEY);
  }

  setTokenLocal(token: string): void {
    localStorage.setItem(this.BASEDEREF_KEY, token);
  }
}
